export default function * success (res) {
  // console.log('Success: ', res)
}
